import "./styles.scss";

import Dialog from "components/ui/dialog";
import { BaIconClose, BaIconFacebook, BaIconMessenger, BaIconShare2, BaIconWhatsapp } from "components/ui/icons";
import copy from "copy-to-clipboard";
import { useApp } from "hooks/app";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { AiOutlineLink } from "react-icons/ai";
import { IoChatbubblesOutline } from "react-icons/io5";
import { FacebookMessengerShareButton, FacebookShareButton, WhatsappShareButton } from "react-share";

import { Button, IconButton } from "@mui/material";

const ShareOptions = ({
  useNativeShare,
  onClick,
  onSuccess,
  onError,
  onClose,
  title,
  text,
  url,
  smsLink,
  buttonTitle,
  textButtonTitle,
  shareOptionsButtonTitle,
  copyLinkButtonTitle,
  socialSharePrependTitle,
  className,
  children,
}) => {
  const [sharePopupOpen, setSharePopupOpen] = useState(false);
  const { showAlert, social } = useApp();

  const onCopy = () => {
    if (url) {
      copy(`${url}`);
      onSuccess && onSuccess();
      showAlert({ message: `Link copied! To use it, open your email or message app and use the 'Paste' option.` });
    }
  };

  const onOpenShareNative = async () => {
    onClick && onClick();
    try {
      // eslint-disable-next-line no-undef
      await navigator.share({
        text,
        title,
        url,
      });
      onSuccess && onSuccess();
    } catch (e) {
      if (e.name !== "AbortError" && e.name !== "InvalidStateError") {
        onError && onError(e);
        setSharePopupOpen(true);
      }
    }
  };

  const onOpenSharePopup = () => {
    onClick && onClick();
    setSharePopupOpen(true);
  };

  const onCloseSharePopup = () => {
    onClose && onClose();
    setSharePopupOpen(false);
  };

  return (
    <div className={`share-options-container ${className}`}>
      {children ? (
        <>
          {useNativeShare ? (
            <div onClick={onOpenShareNative} className="share-button-container" tabIndex="0">
              {children}
            </div>
          ) : (
            <div onClick={onOpenSharePopup} className="share-button-container" tabIndex="0">
              {children}
            </div>
          )}
        </>
      ) : (
        <>
          {useNativeShare ? (
            <>
              <Button className="share-option-button" href={smsLink} startIcon={<IoChatbubblesOutline style={{ fontSize: "1.6rem" }} />}>
                {textButtonTitle}
              </Button>
              <Button variant="text" className="share-option-link-button" onClick={onOpenShareNative}>
                {shareOptionsButtonTitle}
              </Button>
            </>
          ) : (
            <Button className="share-option-button" onClick={onOpenSharePopup} startIcon={<BaIconShare2 style={{ fontSize: "1.6rem", marginTop: "-5px" }} />}>
              {buttonTitle}
            </Button>
          )}
        </>
      )}
      <Dialog className="share-options-list-dialog" open={sharePopupOpen} onClose={onCloseSharePopup}>
        <IconButton onClick={onCloseSharePopup} alt="Close Dialog" title="Close Dialog" className="share-options-list-dialog-close">
          <BaIconClose />
        </IconButton>
        <div className="share-options-list">
          <Button color="transparent" className="share-options-list-button" href={smsLink} startIcon={<IoChatbubblesOutline />}>
            {textButtonTitle}
          </Button>
          <Button color="transparent" className="share-options-list-button" onClick={onCopy} startIcon={<AiOutlineLink />}>
            <span>{copyLinkButtonTitle}</span>
          </Button>
          <FacebookShareButton url={url} onShareWindowClose={onSuccess}>
            <Button href="#" color="transparent" className="share-options-list-button" startIcon={<BaIconFacebook />}>
              {socialSharePrependTitle} facebook
            </Button>
          </FacebookShareButton>
          <FacebookMessengerShareButton url={url} onShareWindowClose={onSuccess} appId={social.facebookAppId} redirectUri="https://facebook.com">
            <Button href="#" color="transparent" className="share-options-list-button" startIcon={<BaIconMessenger />}>
              {socialSharePrependTitle} messenger
            </Button>
          </FacebookMessengerShareButton>
          <WhatsappShareButton url={url} onShareWindowClose={onSuccess} title={title}>
            <Button href="#" color="transparent" className="share-options-list-button" startIcon={<BaIconWhatsapp />}>
              {socialSharePrependTitle} whatsaspp
            </Button>
          </WhatsappShareButton>
        </div>
      </Dialog>
    </div>
  );
};

ShareOptions.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  useNativeShare: PropTypes.bool,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  smsLink: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  textButtonTitle: PropTypes.string,
  copyLinkButtonTitle: PropTypes.string,
  socialSharePrependTitle: PropTypes.string,
  shareOptionsButtonTitle: PropTypes.string,
  onClick: PropTypes.func,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onClose: PropTypes.func,
};

ShareOptions.defaultProps = {
  className: "",
  textButtonTitle: "Send text message",
  copyLinkButtonTitle: "Copy Link",
  socialSharePrependTitle: "Share via",
  shareOptionsButtonTitle: "view all share options",
  onClick: undefined,
  onSuccess: undefined,
  onError: undefined,
  onClose: undefined,
};

export default ShareOptions;
